module.exports = __webpack_public_path__ + "static/paymentMethod_202603-a9c567960ec445d006ab5ae9c1582ec7.png";